import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0393cf8e")

_pushScopeId("data-v-0393cf8e")
const _hoisted_1 = { class: "card mb-5 p-4" }
const _hoisted_2 = { class: "form-check-label fw-bold" }
const _hoisted_3 = { class: "label-holder" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar-alt" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.systemSettings, (status, index) => {
      return (_openBlock(), _createBlock("div", {
        class: "subscription-status",
        key: index
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.capitalizeWords(status.key.split("_").join(" "))), 1)
            ]),
            _createVNode(_component_el_switch, {
              onChange: ($event: any) => (_ctx.updateSubscriptionStatus(status.id)),
              modelValue: _ctx.statuses[index],
              "onUpdate:modelValue": ($event: any) => (_ctx.statuses[index] = $event)
            }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
          ])
        ])
      ]))
    }), 128))
  ], 64))
})